import { ErrorCodes } from 'liveReportService'

const ErrorCodeToTranslationKey: { [Key in ErrorCodes]?: string } = {
  [ErrorCodes.SessionKicked]: 'liveReportStatusCode.multipleLoginDetected',
  [ErrorCodes.InvalidReportId]: 'liveReportStatusCode.notAvailable',
  [ErrorCodes.UserNotActive]: 'invalidEmailOrReportKey',
  [ErrorCodes.OwnerNotActive]: 'liveReportStatusCode.notAvailable',
  [ErrorCodes.InvalidIpAddress]: 'liveReportStatusCode.invalidIPAddress',
  [ErrorCodes.ConcurrentSessionLimit]: 'liveReportStatusCode.userLimit',
  [ErrorCodes.ReportNotFound]: 'liveReportStatusCode.notAvailable',
  [ErrorCodes.InvalidEmailOrReportKey]: 'invalidEmailOrReportKey',
  [ErrorCodes.PermissionDenied]: 'permissionDenied',
  [ErrorCodes.InvalidSessionId]: 'liveReportStatusCode.refreshLiveReport'
}

export default ErrorCodeToTranslationKey
